import { render, staticRenderFns } from "./addAppic.vue?vue&type=template&id=088a0774&scoped=true&"
import script from "./addAppic.vue?vue&type=script&lang=js&"
export * from "./addAppic.vue?vue&type=script&lang=js&"
import style0 from "./addAppic.vue?vue&type=style&index=0&id=088a0774&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088a0774",
  null
  
)

export default component.exports